import { ReactNode, useContext, useMemo, type FormEvent } from 'react';
import { AppProvider } from './contexts/AppContext';
import { AuthProvider } from './contexts/AuthContext';
import { OrganizationsProvider } from '../contexts/OrganizationsContext';
import type { User } from './data/houses';
import { UserContext } from '../contexts/UserContext';

interface HouseKioskShellProps {
  children: ReactNode;
  userType?: User['type'];
  houseId?: string;
  onLogoutRedirect?: () => void;
}

export default function HouseKioskShell({
  children,
  userType,
  houseId,
  onLogoutRedirect,
}: HouseKioskShellProps) {
  const { userProfile, handleLogout } = useContext(UserContext);

  const overrideUser = useMemo(() => {
    if (!userType) return undefined;
    return {
      id: userProfile?.userId ?? userType,
      type: userType,
      houseId,
      password: 'acorn',
    } satisfies User;
  }, [houseId, userProfile?.userId, userType]);

  const onLogout = userType
    ? () => {
        if (onLogoutRedirect) {
          onLogoutRedirect();
          return;
        }
        handleLogout({ preventDefault: () => {} } as FormEvent);
      }
    : undefined;

  return (
    <OrganizationsProvider>
      <AppProvider>
        <AuthProvider overrideUser={overrideUser} onLogout={onLogout}>
          {children}
        </AuthProvider>
      </AppProvider>
    </OrganizationsProvider>
  );
}
